import React from 'react'
import { useState, useEffect, useContext } from "react"
import { Col } from 'reactstrap'
import * as toastr from "toastr"

import Loader from "Placements/Components/Loader"
import API from "Placements/API"
import getConfig from "Placements/Utils/GetRequestConfig.util"
import * as iconBack from 'Placements/Assets/img/icon/arrow-back-purple.png'
import UserContext from "Placements/User.context"
import Button from 'Placements/Components/Button'
import Dropdown from 'Placements/Components/Dropdown'
import Styled from 'styled-components'


type Entry = {
    key: number,
    value: String
}

const Estados: Array<Entry> = [
    { key: 1, value: 'Acre' },
    { key: 2, value: 'Alagoas' },
    { key: 3, value: 'Amapá' },
    { key: 4, value: 'Amazonas' },
    { key: 5, value: 'Bahia' },
    { key: 6, value: 'Ceará' },
    { key: 7, value: 'Distrito Federal' },
    { key: 8, value: 'Espírito Santo' },
    { key: 9, value: 'Goiás' },
    { key: 10, value: 'Maranhão' },
    { key: 11, value: 'Mato Grosso' },
    { key: 12, value: 'Mato Grosso do Sul' },
    { key: 13, value: 'Minas Gerais' },
    { key: 14, value: 'Pará' },
    { key: 15, value: 'Paraíba' },
    { key: 16, value: 'Paraná' },
    { key: 17, value: 'Pernambuco' },
    { key: 18, value: 'Piauí' },
    { key: 19, value: 'Rio de Janeiro' },
    { key: 20, value: 'Rio Grande do Norte' },
    { key: 21, value: 'Rio Grande do Sul' },
    { key: 22, value: 'Rondônia' },
    { key: 23, value: 'Roraima' },
    { key: 24, value: 'Santa Catarina' },
    { key: 25, value: 'São Paulo' },
    { key: 26, value: 'Sergipe' },
    { key: 27, value: 'Tocantins' },
]

const DivStyled = Styled.div`
    margin: 0 2rem;

    .dropdown {
        margin: 0.5rem 0;
    }
`
const LinkStyled = Styled.a`
    font-weight: 800;
    font-size: 1.3rem;
    display: flex;
    place-content: center;
`
const ButtonStyled = Styled(Button)`
    width: auto;    
    align-self: center;
    margin-bottom: -40px;
`

const Formulario = (props: any) => {

    const { usuario }: any = useContext(UserContext)

    const [isLoading, setLoading] = useState(false)
    const [cidades, setCidades] = useState([]);
    const [escolas, setEscolas] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {

        if (usuario == null || usuario.Id_Usuario == null) {
            onLogout()
        }

        API.Usuario.GetSchool({ idUsuario: usuario.Id_Usuario }, getConfig())
            .then((response: any) => {
                const school = response.data
                if (school && school.unidadeYazigi) {
                    const cidadesMaped = school.cidades.map((each: string, idx: number): any => { return { key: idx, value: each } })
                    const escolasMaped = school.unidades.map((each: any, idx: number): any => { return { key: idx, value: each.Nome, cod: each.Cod_Unidade } })
                    setCidades(cidadesMaped)
                    setEscolas(escolasMaped)
                    setSelected({
                        estado: Estados.find(each => each.value == school.unidadeYazigi.Estado),
                        cidade: cidadesMaped.find((each: Entry) => each.value == school.unidadeYazigi.Cidade),
                        escola: escolasMaped.find((each: Entry) => each.value == school.unidadeYazigi.Nome),
                    })
                } else {
                    setSelected({
                        estado: { key: 25, value: 'São Paulo' },
                        cidade: null,
                        escola: null,
                    })
                    HandleEstadoChange({ value: 'São Paulo' })
                }
            }).catch((error: any) => {
                toastr.error('Não foi possível carregar informações', error);
                onLogout()
            }).finally(() => {
                setLoading(false)
            })
    }, [])


    const goToNewTest = async (e: any) => {
        API.Usuario.CreateTest({
            idUsuario: usuario.Id_Usuario,
            Estado: selected.estado.value,
            Cidade: selected.cidade.value,
            Nome: selected.escola.value,
            Cod_Unidade: escolas.find(each => each.value == selected.escola.value).cod
        }, getConfig())
            .then((resp: any) => {
                window.location.href = "#/choose-language"
            })
            .catch((error: any) => {
                toastr.error('Não foi possível criar teste.', error);
            })
    }

    const HandleEscolaChange = (e: any) => {
        setSelected({ ...selected, escola: e })
    }

    const HandleCidadeChange = (e: any) => {

        setEscolas([])

        API.Unidades.GetUnidades({ cidade: e.value, estado: selected.estado.value })
            .then((response: any) => {
                if (response.data) {
                    const escolasMap = response.data.map((each: any, idx: number): any => { return { value: each.Nome, key: idx, cod: each.Cod_Unidade } })
                    setEscolas(escolasMap)
                    setSelected({ ...selected, cidade: e, escola: null })
                } else {
                    setEscolas([])
                }
            })
    }

    const HandleEstadoChange = (e: any) => {
        API.Unidades.GetCidades({ estado: e.value })
            .then((response: any) => {
                if (response.data && response.data) {
                    const cidadesMAp = response.data.map((each: Array<string>, idx: number): any => { return { value: each, key: idx } })
                    setCidades(cidadesMAp)
                    setEscolas([])
                    setSelected({ estado: e, cidade: null, escola: null })
                }
            })
    }

    const onLogout = () => {
        props.onLogout()
        window.location.href = "#/login"
    }

    return (
        <Col md={12} className="form-welcome">
            {isLoading && <Loader />}
            <div className="top">
                <div onClick={onLogout} >
                    <img src={iconBack} />
                </div>
            </div>
            <div>
                {cidades && selected &&
                    <>
                        <h3 className="form-title">Onde você quer estudar?</h3>
                        <p className="form-txt">Vamos descobrir qual é a escola mais próxima de você e aí a gente começa o teste, OK?</p>
                        <DivStyled>
                            <Dropdown
                                value={selected.estado}
                                options={Estados}
                                onChange={HandleEstadoChange} />
                            <Dropdown
                                value={selected.cidade}
                                options={cidades}
                                onChange={HandleCidadeChange}
                                placeholder={"Cidade"} />
                            {<Dropdown
                                value={selected.escola}
                                options={escolas}
                                onChange={HandleEscolaChange}
                                placeholder={"Escola"} />
                            }
                            <Button
                                className="form-btn btn"
                                onClick={goToNewTest}
                                disabled={selected.estado == null || selected.cidade == null || selected.escola == null}
                            >
                                Iniciar Teste
                            </Button>
                        </DivStyled>
                    </>
                }
            </div>
        </Col>
    )
}

export default Formulario